import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './toggleCollection.scss';

import React, { useState, useEffect } from 'react';
import { localStorageHelper, STORAGE_KEY } from '@umu/umu-storage';
import { cancelCollection, addCollection } from '@umu/umu-api';
import { ECollectionType } from '@umu/umu-types';

import { components, services } from 'common';
const { CustomDialog } = components;
const { Toast } = services;

import { FirstCollectDialog } from '../../../@firstCollectDialog/firstCollectDialog';
import { isRegisterUser } from '../../../../services/accountService';
import showQuickRegisterDialog from '../../../account/@quickRegisterDialog/quickRegisterDialog';
import { isFromCourseMiniApp } from '../../../../@utils/umuUtil';

interface IProps {
    children: React.ReactNode;
    objectId: number;
    objectType: ECollectionType;
    isCollected: boolean;
    onChange: (val: boolean) => void;
}

export default function ToggleCollection(props: IProps) {
    const [isCollected, setIsCollected] = useState(props.isCollected);

    useEffect(() => {
        setIsCollected(props.isCollected);
    }, [props.isCollected]);

    const onToggle = () => {
        if (!isRegisterUser()) {
            showQuickRegisterDialog({
                dialogType: 'PARTICIPATE',
            });
            return;
        }
        let fn = addCollection;
        if (isCollected) {
            fn = cancelCollection;
        }
        fn({
            obj_id: props.objectId,
            obj_type: props.objectType,
        }).then((ret) => {
            const isFirstCollect = localStorageHelper.get(STORAGE_KEY.SET_IS_COLLECT_STATE) !== '1';
            if (!isCollected && isFirstCollect && !isFromCourseMiniApp()) {
                localStorageHelper.set(STORAGE_KEY.SET_IS_COLLECT_STATE, '1');
                CustomDialog({
                    canClose: true,
                    width: '3rem',
                    childProps: {},
                    contentComponent: FirstCollectDialog,
                });
            }
            if (ret.data.status === 1) {
                setIsCollected(!isCollected);
                props.onChange(!isCollected);
                Toast.show(isCollected ? lang('已取消收藏') : lang('已收藏'));
            }
        });
    };
    const render = () => {
        return (
            <div className={'toggle-collection' + (isCollected ? ' is-collected' : '')} onClick={onToggle}>
                {props.children}
            </div>
        );
    };
    return render();
}
